import { Injectable } from "@angular/core";
import { EmailNotificationAddresses, DefaultService } from "@psnb/psnb-api";
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PSEmailDistroService {
    constructor(private powerSupplyService: DefaultService) {
        this.getEmailNotificationAddresses();
    }

    getEmailNotificationAddresses() {
        return this.powerSupplyService.getEmailNotificationAddresses().pipe(map(result => result));
    }

    createEmailNotificationAddresses(model: EmailNotificationAddresses) {
        return this.powerSupplyService.createEmailNotificationAddresses(model).pipe(map(result => result));
    }

    updateEmailNotificationAddresses(model: EmailNotificationAddresses) {
        return this.powerSupplyService.updateEmailNotificationAddresses(model).pipe(map(result => result));
    }

    deleteEmailNotificationAddresses(emailAddress) {
        return this.powerSupplyService.deleteEmailNotificationAddresses(emailAddress).pipe(map(result => result));
    }
}
